module.exports = __webpack_public_path__ + "static/media/1019945.ba85e7f7.png";